import { Helper } from 'src/app/shared/helpers/helper';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { User } from 'src/app/shared/models/user.model';
import { ENDPOINT, BASE_BACKEND } from 'src/app/shared/http/api';


@Injectable()
export class LoginService {
  constructor(
    private http: HttpClient,
    private spinner: NgxSpinnerService,
  ) { }

  login(data): Observable<User> {
    this.spinner.show();
    return this.http
      .post(
        `${BASE_BACKEND}${ENDPOINT.login.authlogin}`, data.value
      )
      .pipe(
        map(
          // tslint:disable-next-line: no-shadowed-variable
          (data: User) => {
            this.spinner.hide();
            return data;
          }
        ),
        catchError(
          (error) => {
            this.spinner.hide();
            return throwError(error);
          }
        )
      );
  }

  forgetPassword(user) {
    return this.http
      .put(`${BASE_BACKEND}${ENDPOINT.login.resetPasswprd}`, { username: user })
      .pipe(
        map((data) => data),
        catchError(Helper.handleError)
      );
  }

}
